/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName, useTheme } from '../../contexts/ThemeContext';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/leaderboard.module.scss';

const propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            points: PropTypes.number,
            name: PropTypes.string,
        }),
    ),
    count: PropTypes.number,
    className: PropTypes.string,
};

function Leaderboard({ items = [], count = null, className = null }) {
    const { name: theme = null } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const isSportsGame = theme === 'nhl' || theme === 'nfl';

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.header}>
                <div className={classNames([styles.col, styles.index])}>
                    <div className={styles.inner}>Top {count}</div>
                </div>
                <div className={classNames([styles.col, styles.label])}>
                    <div className={styles.inner}>
                        {theme === 'nhl' ? (
                            <FormattedMessage defaultMessage="Name" description="Table header" />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Participants"
                                description="Table header"
                            />
                        )}
                    </div>
                </div>
                <div className={classNames([styles.col, styles.points])}>
                    <div className={styles.inner}>Points</div>
                </div>
            </div>
            <div className={styles.rows}>
                {items.map(
                    (
                        {
                            points,
                            name = null,
                            abbreviatedName = null,
                            jobTitle = null,
                            region = null,
                            venueCity = null,
                        },
                        index,
                    ) => (
                        <div className={styles.row} key={`row-${index}`}>
                            <div className={classNames([styles.col, styles.index])}>
                                <div className={styles.inner}>
                                    {index < 9 ? `0${index + 1}` : index + 1}
                                </div>
                            </div>
                            <div className={classNames([styles.col, styles.label])}>
                                <div className={styles.inner}>
                                    {!isSportsGame && name !== null ? (
                                        <div className={styles.name}>{name}</div>
                                    ) : null}
                                    {isSportsGame && abbreviatedName !== null ? (
                                        <div className={styles.name}>{abbreviatedName}</div>
                                    ) : (
                                        <div className={styles.name}>-</div>
                                    )}
                                    {theme !== 'tradition' && !isSportsGame && jobTitle !== null ? (
                                        <div className={styles.jobTitle}>{jobTitle}</div>
                                    ) : null}
                                    {theme !== 'tradition' && !isSportsGame && region !== null ? (
                                        <div className={styles.region}>{region}</div>
                                    ) : null}
                                    {theme === 'tradition' &&
                                    !isSportsGame &&
                                    venueCity !== null ? (
                                        <div className={styles.region}>{venueCity}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className={classNames([styles.col, styles.points])}>
                                <div className={styles.inner}>
                                    {points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                                </div>
                            </div>
                        </div>
                    ),
                )}
            </div>
        </div>
    );
}

Leaderboard.propTypes = propTypes;

export default Leaderboard;
